
<div class="bagkground-image">
<nav class="navbar">
  <div class="logo">Innovative Vision</div>
  <!-- Hamburger Menu -->
  <div class="hamburger" (click)="toggleMenu()">
    &#9776; 
  </div>
  <ul class="nav-links" [class.active]="menuOpen">
    <li><a routerLinkActive="active-link" routerLink="/home" (click)="closeMenu()">Home</a></li>
    <li><a routerLinkActive="active-link" routerLink="/aboutUs" (click)="closeMenu()">About Us</a></li>
    <!-- <li><a routerLinkActive="active-link" routerLink="/program" href="#" (click)="closeMenu()">Programs</a></li> -->
    <li><a routerLinkActive="active-link" routerLink="/program" href="#" (click)="closeMenu()">Our Programs</a></li>
    <li><a routerLinkActive="active-link" routerLink="/event" href="#" (click)="closeMenu()">Annual Events</a></li>
    <li><a routerLinkActive="active-link" routerLink="/home" (click)="closeMenu()">Coaches</a></li>
    <li><a routerLinkActive="active-link" routerLink="/gallery" href="#" (click)="closeMenu()">Gallery</a></li>
    <li><a routerLinkActive="active-link" routerLink="/mainContactUs" (click)="closeMenu()">Contact Us</a></li>
    <li><a routerLinkActive="active-link" routerLink="/career" href="#" (click)="closeMenu()">Career</a></li>
  </ul>
</nav>
</div>

